module.exports = __webpack_public_path__ + "static/img/1_0047.1ca55ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0047.jpg
// module id = qE16
// module chunks = 0